import { DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { func, string } from 'prop-types';
import React, { useState } from 'react';
import { Form as FinalForm } from 'react-final-form';
import { SWDialog } from '../../components/mui/Dialog';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { SecondaryButton, SecondaryTextButton } from '../mui/Button';
import css from './TimezoneSelector.module.css';

// Import the timezone select field directly
import classNames from 'classnames';
import FieldTimeZoneSelect from '../../containers/EditListingPage/EditListingWizard/EditListingAvailabilityPanel/FieldTimeZoneSelect';

/**
 * Dialog for selecting a timezone
 */
const TimezoneDialog = props => {
  const { isOpen, onClose, onSubmit, currentTimezone, intl } = props;

  const initialValues = {
    timezone: currentTimezone || '',
  };

  return (
    <FinalForm
      initialValues={initialValues}
      onSubmit={onSubmit}
      render={formRenderProps => {
        const { form, submitting } = formRenderProps;

        return (
          <SWDialog
            open={isOpen}
            onClose={onClose}
            PaperProps={{
              sx: { minWidth: { md: 390 }, maxHeight: '100vh' },
            }}
          >
            <DialogTitle>
              <FormattedMessage
                id="TimezoneSelector.dialogTitle"
                defaultMessage="Select Timezone"
              />
            </DialogTitle>

            <DialogContent dividers>
              <div className={css.dialogContent}>
                <FieldTimeZoneSelect
                  id="timezone"
                  name="timezone"
                  label={intl.formatMessage({
                    id: 'TimezoneSelector.timezoneLabel',
                    defaultMessage: 'Timezone',
                  })}
                />
              </div>
            </DialogContent>

            <DialogActions>
              <SecondaryTextButton onClick={onClose}>
                <FormattedMessage id="TimezoneSelector.cancel" defaultMessage="Cancel" />
              </SecondaryTextButton>
              <SecondaryButton
                disabled={submitting}
                onClick={() => {
                  form.submit();
                  onClose();
                }}
              >
                <FormattedMessage id="TimezoneSelector.save" defaultMessage="Save" />
              </SecondaryButton>
            </DialogActions>
          </SWDialog>
        );
      }}
    />
  );
};

/**
 * Component for displaying and changing a timezone
 */
const TimezoneSelector = props => {
  const { currentTimezone, onChange, intl, rootClassName } = props;
  const [isDialogOpen, setDialogOpen] = useState(false);
  const classes = classNames(rootClassName || css.root);

  const handleOpenDialog = () => {
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };

  const handleSubmit = values => {
    onChange(values.timezone);
    return values;
  };

  // Don't render until we have a timezone
  if (!currentTimezone) return null;

  return (
    <div className={classes}>
      <div className={css.container}>
        <FormattedMessage
          id="TimezoneSelector.inYourLocalTimezone"
          defaultMessage="In your local timezone ({timeZone})"
          values={{ timeZone: currentTimezone }}
        />
        <button type="button" className={css.changeButton} onClick={handleOpenDialog}>
          <FormattedMessage id="TimezoneSelector.change" defaultMessage="Change" />
        </button>

        <TimezoneDialog
          isOpen={isDialogOpen}
          onClose={handleCloseDialog}
          onSubmit={handleSubmit}
          currentTimezone={currentTimezone}
          intl={intl}
        />
      </div>
    </div>
  );
};

TimezoneSelector.propTypes = {
  currentTimezone: string,
  onChange: func,
  intl: intlShape,
};

export default TimezoneSelector;
